import styled from "styled-components";
import { Input, Select, Col } from "antd";

export const Box = styled.div`
  background-color: rgba(0, 103, 120, 0.15);
  position: relative;
  padding: 20px 20px !important;
  bottom: 18px;
  box-shadow: 0px 10px 10px rgba(225, 225, 225, 0.5);
  animation: slide-up 1s ease;
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(-10px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  &:after,
  &:before {
    bottom: 100%;
    left: ${props => props.left}%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;

    @media (max-width: 991px) {
      left: 57%;
    }
  }

  &:after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: rgba(0, 103, 120, 0.15);
    border-width: 10px;
    margin-left: -30px;
  }
  @media (max-width: 991px) {
    margin-top: 30px;
    padding: 20px 20px !important;
  }
`;
export const SelectBox = styled(Select)`
  .ant-input:placeholder-shown {
    margin-left: 6px;
    color: #d4d4d4;
    font-size: 1rem;
    font-family: HelveticaNeue;
    @media (max-width: 991px) {
      font-size: 0.875rem;
    }
  }

  .ant-select-selection {
    border-radius: 0px;
  }

  .ant-select-selection--multiple .ant-select-selection__rendered {
    height: 40px;
    margin-bottom: -4px;
  }

  .ant-select-arrow {
    top: 0;
    padding: 16px 13px;
    background-color: #f5f5f5;
    margin: 1px 1px;
    right: 0;
    bottom: 0;
  }

  .ant-select-selection__rendered {
    height: 40px;
  }
  .ant-select-search__field {
    margin-top: -4px;
    height: 40px;
  }

  .ant-select-selection--single {
    height: 40px;
  }

  .ant-select-selection__clear {
    top: 50%;
    margin-right: 30px;
  }

  .ant-select-selection__rendered > ul > li.ant-select-selection__choice {
    margin-top: 8px;
    border-radius: 0px;
  }

  .ant-select-selection--single .ant-select-selection-selected-value {
    margin-top: 4px;
    @media (min-width: 320px) and (max-width: 768px){
      color: ${props => props.theme.fontColors.textColor};
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: ${props => props.theme.fontSize.secondary};
     }
  }

  //Select box hover and focus state
  .ant-select-selection {
    border-radius: 0px !important;
    box-shadow: 0 0 0 0 ${props => props.theme.border.pill} !important;
    &:hover {
      border-color: ${props => props.theme.border.pill} !important;
    }
    &:focus {
      border: 1px solid ${props => props.theme.border.pill} !important;
      outline-color: ${props => props.theme.border.inputBox} !important;
      outline-width: 1px;
      box-shadow: 0 0 0 0 ${props => props.theme.border.inputBox} !important;
    }
  }

  //select box dimensions
  .ant-select-selection--single {
    height: 40px;
    //select box arrow
    .ant-select-arrow {
      top: 0;
      padding: 14px 13px;
      background-color: ${props => props.theme.backgroundColor.pill};
      margin: 0px;
      right: 0;
      bottom: 0;
    }
    //placeholder
    .ant-select-selection__placeholder,
    .ant-select-search__field__placeholder {
      margin-top: -6px;
      font-size: 1rem;
      font-family: HelveticaNeue;
      @media (max-width: 991px) {
        font-size: 0.875rem;
      }
    }
    .ant-select-selection__rendered {
      //select box selected value
      .ant-select-selection-selected-value {
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        font-size: ${props => props.theme.fontSize.primary};
        font-weight: ${props => props.theme.fontWeight.normal};
        font-style: normal;
        font-stretch: ${props => props.theme.fontStretch.normal};
        line-height: ${props => props.theme.lineHeight.primary} !important;
        color: ${props => props.theme.fontColors.textColor};
        margin-top: 12px;
        white-space: nowrap;
        width: ${props => (props.width ? `${props.width - 50}px` : "150px")};
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 767px) {
          font-size: ${props => props.theme.fontSize.secondary};
          line-height: ${props => props.theme.lineHeight.secondary} !important;
        }
      }
    }
  }
`;

export const InputBox = styled(Input)`
  height: 40px;
`;

export const BottomWrapper = styled.div`
padding-top:20px
  display : flex;
  justify-content: space-between;
`;
export const FilterCol = styled(Col)`
  padding-bottom: 1.5625rem;
  max-height: 6.25rem;

  @media (max-width: 991px) {
    padding: 10px 10px;
  }
`;

export const TabTitles = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: : ${props => props.theme.fontWeight.normal};
  font-stretch: : ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  text-align:left;
  margin-bottom:0.3125rem;
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    margin-top:0.3125rem;
  }
`;

export const CloseText = styled.button`
  font-size: ${props => props.theme.fontSize.primary};
  background: none;
  border: none;
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  svg {
    font-size: ${props => props.theme.fontSize.quaternary};
  }
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const PoweredBy = styled.span`
  align-items: center;

  span {
    margin-right: 10px;
    font-size: 10px;
  }
`;
